import React from 'react';
import { ChevronLeft, ChevronRight, X, Film } from 'lucide-react';

// The only controls in theatre mode: previous / next video and exit.
const TheatreControls = ({ seated, video, index, total, onPrev, onNext, onExit, isMobile }) => (
  <div className={`fixed left-1/2 -translate-x-1/2 z-50 ${isMobile ? 'bottom-4 w-[94vw]' : 'bottom-5 w-[min(92vw,640px)]'}`}>
    <div className="flex items-center gap-2 bg-black/70 backdrop-blur-sm text-white rounded-full shadow-2xl px-2 py-1.5 border border-white/10">
      <button onClick={onPrev} disabled={!seated} className="h-10 w-10 shrink-0 rounded-full flex items-center justify-center hover:bg-white/15 disabled:opacity-40" title="Previous video (←)">
        <ChevronLeft size={22} />
      </button>
      <div className="flex-1 min-w-0 text-center leading-tight">
        <div className="text-[11px] uppercase tracking-widest text-amber-300 flex items-center justify-center gap-1">
          <Film size={12} /> {seated ? `The making of · ${index + 1} of ${total}` : 'Taking your seat…'}
        </div>
        <div className="text-sm font-medium truncate">{video?.title}</div>
      </div>
      <button onClick={onNext} disabled={!seated} className="h-10 w-10 shrink-0 rounded-full flex items-center justify-center hover:bg-white/15 disabled:opacity-40" title="Next video (→)">
        <ChevronRight size={22} />
      </button>
      <button onClick={onExit} className="h-10 shrink-0 rounded-full flex items-center gap-1 px-3 bg-white/15 hover:bg-white/25 text-sm" title="Exit theatre (Esc)">
        <X size={16} /> Exit
      </button>
    </div>
  </div>
);

export default TheatreControls;
